import { Component, OnInit } from '@angular/core';
import { PlanModel } from '../../models/plan.model';
import { PlanService } from '../../services/plan.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.less']
})
export class PlanComponent implements OnInit {

  plans: Array<PlanModel> = new Array<PlanModel>();

  constructor(private planService: PlanService,
    private router: Router) { }

  ngOnInit() {
    this.planService.getAll()
      .then((_plans: Array<PlanModel>) => {
        this.plans = _plans;
      });
  }

  goToDependents() {
    this.router.navigate(['general/currentSubscription']);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/plan/plan.component.ts